import { required, confirmed, length, email } from "vee-validate/dist/rules"
import { extend } from "vee-validate"

extend("required", {
    ...required,
    message: "El campo es requerido"
})

extend("email", {
    ...email,
    message: "El campo debe ser un correo válido"
})

extend("confirmed", {
    ...confirmed,
    message: "This field confirmation does not match"
})

extend("length", {
    ...length,
    message: "This field must have 2 options"
})
